<template>
  <upstream-sewage-wizard tool-name="Volume" title-translation-path="sidebar.upstreamSewage.volumeTitle">
  </upstream-sewage-wizard>
</template>

<script>
import UpstreamSewageWizard from '@/components/UpstreamSewageWizard.vue';

export default {
  name: 'UpstreamSewageVolume',
  components: {
    UpstreamSewageWizard,
  },
};
</script>
